import './App.css';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Intro from './components/Intro/Intro';
import Navbar from './components/Navbar/Navbar';
import Projects from './components/projects/Projects';
import Skills from './components/Skills/Skills';
import Stats from './components/Stats/Stats';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Intro/>
      <About/>
       <Skills/>
       <Projects/>
      <Stats/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
